export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'OPEN_MODAL';
